import React from 'react';
import Button from '../../../../components/Button/Button';
import { PortalWithState } from 'react-portal';
import SetWaterSiteModal from './SetWaterSiteModal';
import { IdArrayInput } from '../../../../hooks/useTablePages';

type WaterServicesActionsProps = { ids: IdArrayInput };

const WaterServicesActions: React.FC<WaterServicesActionsProps> = ({
  ids,
}): JSX.Element => {
  return (
    <>
      <PortalWithState closeOnOutsideClick closeOnEsc>
        {({ openPortal, closePortal, portal }) => (
          <>
            <Button
              variant="outline"
              disabled={!ids.length}
              icon="edit"
              onClick={openPortal}
            >
              Set Hazard Site
            </Button>
            {portal(
              <SetWaterSiteModal
                siteType="HAZARD_ASSESSMENT"
                serviceIds={ids}
                onClose={closePortal}
              />
            )}
          </>
        )}
      </PortalWithState>
    </>
  );
};

export default WaterServicesActions;
